import { combineReducers } from 'redux';

import addressesReducer from './addresses';
import clientsReducer from './clients';
import customersReducer from './customers';
import eventsReducer from './events';
import resourcesReducer from './resources';
import sessionsReducer from './sessions';
import staffReducer from './staff';

const entityReducer = combineReducers({
  addresses: addressesReducer,
  clients: clientsReducer,
  customers: customersReducer,
  events: eventsReducer,
  resources: resourcesReducer,
  sessions: sessionsReducer,
  staff: staffReducer,
});

export default entityReducer;
